module.exports = __webpack_public_path__ + "media/images/result_sets/circles/7n6n5n1n-50805e758219f1c32c897ad28ef25a73.svg";